import { CanadaCompanyDetails, Import, ImportGarnishment, ImportPayment, ImportTax, ImportValidationError, PaginatedResponse,YearEndPaginatedResponse, PayRunImportDetail, ROEImportDetail, YearEndImportDetail,YearEndBoxValueHeader,YearEndBoxValues, ImportFileType, YearEndContainerType, YearEndSubmissionType} from "../models/ImportFile";
import { ErrorResponse } from "../models/ErrorResponse";
import { secureFetch as fetch } from "./secureFetch";

export const authenticate = async (): Promise<boolean> => {
  const response = await fetch(`/authentication/login`);
  return await getResponse(response);
};

export const GetCompanyList = async (): Promise<CanadaCompanyDetails[]> => {
  const response = await fetch(`/api/payrollSummary/companyDetails`);
  return await getResponse(response);  
};

export const CheckAssignedCompany = async (): Promise<CanadaCompanyDetails[]| null> => {
  const response = await fetch(`/api/payrollSummary/CheckAssignedCompany`);
  return await getResponse(response);  
};

export const GetImportFiles = async (filterObject: any = {}): Promise<PaginatedResponse> => {
  
  const response = await fetch(`/api/payrollSummary`,
    {
      method: 'POST',
      body: JSON.stringify(filterObject),
    }
  );

  return await getResponse(response);  
};

export const GetYearEndImportFiles = async (filterObject: any = {}): Promise<YearEndPaginatedResponse> => {
  
  const response = await fetch(`/api/payrollSummary/yearend`,
    {
      method: 'POST',
      body: JSON.stringify(filterObject),
    }
  );

  return await getResponse(response);  
};

export const GetImportDetailById = async (importId: number): Promise<number> => {
  
  const response = await fetch(`/api/payrollSummary/importDetail/${importId}`);
  return await getResponse(response);  
};

export const GetImportById = async (importId: number): Promise<Import> => {
  
  const response = await fetch(`api/payrollSummary/import/${importId}`);
  return await getResponse(response);  
};

export const UploadCsv = async (fileName: string, csvContent: string, screenName: string): Promise<any> => {
  const response = await fetch('/api/payrollSummary/uploadcsv', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ fileName, csvContent,screenName })
  });
 
  return await getResponse(response);
};

/**
 * Downloads a file from a URL with security validation
 * @param blobUrl - The URL to download from (blob: or https: only)
 * @param fileName - The name to save the file as
 * @throws Error if URL protocol is not supported or origin is untrusted
 */
export const downloadFileFromUrl = (blobUrl: string, fileName: string): void => {
  let link: HTMLAnchorElement | null = null;
  try {
    // Validate URL scheme (allow only blob: and https:)
    const parsed = new URL(blobUrl);

    if (!['blob:', 'https:'].includes(parsed.protocol)) {
      throw new Error(`Unsupported download URL protocol: ${parsed.protocol}`);
    }

    link = document.createElement('a');
    link.href = parsed.toString();
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
  } catch (error) {
    const errorMessage = error instanceof Error ? error.message : 'Unknown error';
    throw new Error(`Failed to download file: ${errorMessage}`);
  } finally {
    // Ensure cleanup happens even if click throws
    if (link?.parentNode) {
      document.body.removeChild(link);
    }
  }
};

export const GetPayrunImportById = async (importId: number): Promise<PayRunImportDetail> => {
  const response = await fetch(`/api/payrollSummary/import/${importId}/payrun`);
  return await getResponse(response);  
};

export const GetYearEndImportById = async (importId: number, containerTypeId?: number | string): Promise<YearEndImportDetail> => {
  const url = containerTypeId != null
    ? `/api/YearEnd/import/${importId}/YearEnd?containerTypeId=${encodeURIComponent(containerTypeId)}`
    : `/api/YearEnd/import/${importId}/YearEnd`;
  const response = await fetch(url);
  return await getResponse(response);  
};


export const GetPaymentImportDetailById = async (importDetailId: number): Promise<ImportPayment[]> => {
  
  const response = await fetch(`/api/payrollSummary/import-details/${importDetailId}/payments`);
  return await getResponse(response);  
};

export const GetTaxesImportDetailById = async (importDetailId: number, page: number, pageSize: number): Promise<ImportTax[]> => {
  
  const response = await fetch(`/api/payrollSummary/import-details/${importDetailId}/${page}/${pageSize}/taxes`);
  return await getResponse(response);  
};

export const GetGarnishmentImportDetailById = async (importDetailId: number, page: number, pageSize: number): Promise<ImportGarnishment[]> => {
  const response = await fetch(`/api/payrollSummary/import-details/${importDetailId}/${page}/${pageSize}/Garnishment`);
  return await getResponse(response);  
};

export const GetOtherImportDetailById = async (importDetailId: number): Promise<ImportPayment> => {
  
  const response = await fetch(`/api/payrollSummary/import-details/${importDetailId}/others`);
  return await getResponse(response);  
};


export const GetRoeImportById = async (importId: number): Promise<ROEImportDetail> => {
  
  const response = await fetch(`/api/payrollSummary/import/${importId}/roe`);

  return await getResponse(response);  

 
};

export const GetValidationErrorsByImportId = async (importId: number): Promise<ImportValidationError[]> => {
  
  const response = await fetch(`/api/ActionManager/validationError/${importId}/error`);
  return await getResponse(response);
};

export const GetYearEndBoxValueHeaderById = async (ImportDetailsId: number): Promise<YearEndBoxValueHeader> => {  
  const response = await fetch(`/api/YearEnd/GetYearEndBoxValueHeader/${ImportDetailsId}/YearEnd`);
  return await getResponse(response);
};

export const GetYearEndBoxValuesById = async (YearEndImportDetailId: number): Promise<YearEndBoxValues> => {  
  const response = await fetch(`/api/YearEnd/GetYearEndBoxValue/${YearEndImportDetailId}/YearEnd`);
  return await getResponse(response);
};

export const GetImportFileTypes = async (FileCategory: string): Promise<ImportFileType[]> => {
    const response = await fetch(`/api/payrollSummary/file-types?fileCategory=${FileCategory}`); 
    return await getResponse(response);
};

export const GetYearEndContainerTypes = async (): Promise<YearEndContainerType[]> => {
    const response = await fetch(`/api/payrollSummary/container-types`); 
    return await getResponse(response);
}

export const GetYearEndSubmissionTypes = async (): Promise<YearEndSubmissionType[]> => {
    const response = await fetch(`/api/payrollSummary/submission-types`); 
    return await getResponse(response);
}

const getResponse = async (response: Response | Error | null) => {
  let ret = null;
  if (response instanceof Error) {
    throw new ErrorResponse(response.message);
  } else if (response.status === 200) {
    ret = await response.json();
  } else if(response.status === 204) {
  
    return ret;
  } else {
    throw new ErrorResponse(await response.text());
  }
  return ret;
}